import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { InformationBoxComponent } from '../information-box/information-box.component';
import { StafferSettingsStoreService } from '../../staffer-settings-store.service';
import { DismissibleInfoBoxKey } from './dismissible-notification-keys';

@Component({
  selector: 'pr-dismissible-info-box',
  imports: [CommonModule, InformationBoxComponent, MatButtonModule],
  templateUrl: './dismissible-info-box.component.html',
  styleUrl: './dismissible-info-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DismissibleInfoBoxComponent {
  private readonly _stafferSettings = inject(StafferSettingsStoreService);
  private readonly _localDismissed = signal(false);
  private readonly _dismissedKeys = toSignal(
    this._stafferSettings.dismissedInfoBoxes$,
    { initialValue: [] as string[] }
  );

  readonly dismissKey = input.required<DismissibleInfoBoxKey>();
  readonly theme = input<'info' | 'warn'>('info');

  readonly isDismissed = computed(() => {
    if (this._localDismissed()) {
      return true;
    }
    return this._dismissedKeys().includes(this.dismissKey());
  });

  dismiss(): void {
    this._stafferSettings.dismissInfoBox(this.dismissKey());
    this._localDismissed.set(true);
  }
}
